import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.00015 1.58569L12.0002 4.58569L15.0002 1.58569L23.9144 10.4999L12.0002 22.4141L0.0859375 10.4999L9.00015 1.58569ZM10.5859 5.99991L9.00015 4.41412L2.91436 10.4999L12.0002 19.5857L12.9543 18.6315L10.5859 16.2632L12.0002 14.849L14.3685 17.2173L15.3227 16.2632L12.9543 13.8948L14.3685 12.4806L16.7369 14.849L18.0859 13.4999L15.0002 10.4141L12.0002 13.4141L7.58594 8.99991L10.5859 5.99991Z"}}]};

const CooperateFilled = Vue.extend<IconProps>({
  name: 'CooperateFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'cooperate-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CooperateFilled;
